import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';

// ENVs
// import { environment as ENV } from '@environments/environment';

import { TranslatePipe } from '@ngx-translate/core';



@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
  ],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

  protected version: WritableSignal<string> = signal('2.0.0');
  protected date: WritableSignal<Date> = signal(new Date());
}
